export default "__VITE_ASSET__DgHe_F4P__"